import { Booking } from '../../core/models/booking';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';
import { SessionType } from '../../infra/adapters/luminara/session-type/dto/session-type.dto';

export interface ScheduleBookingAsHealerState {
  booking?: Booking;
  clientUserProfileId?: string;
  loadingDataErrors: string[];
  sessionTypes?: SessionType[];
}

export const initialScheduleBookingAsHealerState = () => {
  return { loadingDataErrors: [] } as ScheduleBookingAsHealerState;
};

export interface ScheduleBookingAsHealerAction {
  type:
    | 'BOOKING_SCHEDULED_SUCCESSFULLY'
    | 'BOOKING_SCHEDULING_FAILED'
    | 'CLIENT_USER_PROFILE_CREATED_SUCCESSFULLY'
    | 'CLEAR_BOOKING'
    | 'SESSION_TYPES_LOADED'
    | 'SESSION_TYPES_LOAD_FAILED'
    | 'HEALER_LOGGED_OUT';
  payload?: any;
}

const ScheduleBookingAsHealerReducer = (
  state: ScheduleBookingAsHealerState = initialScheduleBookingAsHealerState(),
  action: ScheduleBookingAsHealerAction
): ScheduleBookingAsHealerState => {
  switch (action.type) {
    case 'BOOKING_SCHEDULED_SUCCESSFULLY': {
      return { ...state, booking: action.payload };
    }
    case 'BOOKING_SCHEDULING_FAILED': {
      const errMsg = extractMessageFromError(action.payload);
      return {
        ...state,
        booking: undefined,
        clientUserProfileId: undefined,
        loadingDataErrors: state.loadingDataErrors.concat(errMsg),
      };
    }
    case 'CLIENT_USER_PROFILE_CREATED_SUCCESSFULLY': {
      return { ...state, clientUserProfileId: action.payload as string };
    }
    case 'SESSION_TYPES_LOADED': {
      return { ...state, sessionTypes: action.payload };
    }
    case 'SESSION_TYPES_LOAD_FAILED': {
      const errMsg = extractMessageFromError(action.payload);
      return { ...state, sessionTypes: undefined, loadingDataErrors: state.loadingDataErrors.concat(errMsg) };
    }
    case 'CLEAR_BOOKING': {
      return { ...state, booking: undefined };
    }
    case 'HEALER_LOGGED_OUT': {
      return initialScheduleBookingAsHealerState();
    }
    default:
      return state;
  }
};

export default ScheduleBookingAsHealerReducer;
